import { Media } from '@/model/post'

import Picture from '../picture'
import ImageWrapper from './imageWrapper'

interface Props extends Media {
  name: string
  href: string
}

const hasFirstElement = (item: string[]) =>
  Array.isArray(item) && item[0] != null

const CardMedia = ({
  images,
  attached_images,
  video_links,
  videos,
  name,
  href,
}: Props) => {
  if (hasFirstElement(images)) {
    return <ImageWrapper image={images[0]} alt={name} href={href} />
  } else if (hasFirstElement(video_links) || hasFirstElement(videos)) {
    return (
      <iframe
        className="w-full h-full aspect-[3/2] block"
        src={video_links[0] || videos[0]}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        loading="lazy"
        allowFullScreen
      />
    )
  } else if (hasFirstElement(attached_images)) {
    return <ImageWrapper image={attached_images[0]} alt={name} href={href} />
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="aspect-[3/2] w-full block"
    >
      <Picture image="/assets/images/lab" imageAlt={name} />
    </a>
  )
}

export default CardMedia
